import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  error: null,
  loading: false,
};

const agentDialStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const agentDialSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const agentDialFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const agentUniqueDialStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const agentUniqueDialSuccess = (state, action) => {
  return updateObject(state, {
    error: null,
    loading: false,
  });
};

const agentUniqueDialFail= (state,action) =>{
    return updateObject(state, {error: action.error, loading: false});
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AGENT_DIAL_START:
      return agentDialStart(state, action);
    case actionTypes.AGENT_DIAL_SUCCESS:
      return agentDialSuccess(state, action);
    case actionTypes.AGENT_DIAL_FAIL:
      return agentDialFail(state, action);
         case actionTypes.AGENT_DIAL_UNIQUE_ID_START:
      return agentUniqueDialStart(state, action);
    case actionTypes.AGENT_DIAL_UNIQUE_ID_SUCCESS:
      return agentUniqueDialSuccess(state, action);
    case actionTypes.AGENT_DIAL_UNIQUE_ID_FAIL:
      return agentUniqueDialFail(state, action); 
    default:
      return state;
  }
};

export default reducer;
